import { PLANOGRAM_CONFIG, WIDTH } from 'shared/config/PlanogramConfig';
import { Arithmetic, CylinderPoint } from 'shared/utils/modulo.util';
import { toFractionDigits } from './float-util';
export const planogramWidth = WIDTH;
export const planogramArithmetic = new Arithmetic(WIDTH);
export default class PlanogramPoint extends CylinderPoint {
    constructor(position) {
        super(planogramWidth);
        if (position)
            this.set(position.x, position.y);
        else
            this.set(0, 0);
    }
}
export function flipEditorY(y) {
    return PLANOGRAM_CONFIG.height / 2 + PLANOGRAM_CONFIG.virtualSphereY - y;
}
export function toEditorPosition(point) {
    return [toFractionDigits(point.x, 2), toFractionDigits(flipEditorY(point.y), 2)];
}
export function fromEditorPosition(point) {
    const [x, y] = point.map(parseFloat);
    return new PlanogramPoint().set(x, flipEditorY(y));
}
